import { useState, useMemo } from 'react';
import './TierList.css';
import Header from '../components/Header';
import DataSelector from './DataSelector';
import { TierRow } from './components/TierRow';
import { WinRatePickScatter } from './components/WinRatePickScatter';
import { useTierList } from './hooks/useTierList';
import { filterHeroesByLane } from './utils/filterHeroesByLane';

export default function TierList() {
  const [beta, setBeta] = useState(0.25);
  const [selectedLane, setSelectedLane] = useState('all');
  
  const { 
    heroes, 
    availableData, 
    loading, 
    dataLoading, 
    error, 
    scrapedAt,
    bigrank,
    setBigrank,
    calculateTiers 
  } = useTierList();

  const filteredHeroes = useMemo(
    () => filterHeroesByLane(heroes, selectedLane),
    [heroes, selectedLane]
  );

  const tierHeroes = useMemo(() => {
    if (filteredHeroes.length === 0) return [];
    return calculateTiers(filteredHeroes, beta);
  }, [filteredHeroes, beta, calculateTiers]);

  const getHeroesByTier = (tier: 'S' | 'A' | 'B' | 'C' | 'D') => {
    return tierHeroes.filter(th => th.tier === tier);
  };

  if (dataLoading) {
    return (
      <div className="tier-list-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>データを読み込み中...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tier-list-page">
      <Header title="ティア表" />

      {availableData.length > 0 ? (
        <DataSelector
          bigrank={bigrank}
          beta={beta}
          scrapedAt={scrapedAt}
          availableData={availableData}
          onBigrankChange={setBigrank}
          onBetaChange={setBeta}
          selectedLane={selectedLane}
          onLaneChange={setSelectedLane}
        />
      ) : (
        <div className="error-message">
          利用可能なデータがありません。Data Management でデータを取得してください。
        </div>
      )}

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading hero data...</p>
        </div>
      ) : (
        <>
          <div className="tier-list-container">
            <TierRow tier="S" heroes={getHeroesByTier('S')} beta={beta} />
            <TierRow tier="A" heroes={getHeroesByTier('A')} beta={beta} />
            <TierRow tier="B" heroes={getHeroesByTier('B')} beta={beta} />
            <TierRow tier="C" heroes={getHeroesByTier('C')} beta={beta} />
            <TierRow tier="D" heroes={getHeroesByTier('D')} beta={beta} />
          </div>
          {heroes.length > 0 && (
            <WinRatePickScatter
              tierHeroes={tierHeroes}
              beta={beta}
              bigrank={bigrank}
              scrapedAt={scrapedAt}
              availableData={availableData}
              onBigrankChange={setBigrank}
              onBetaChange={setBeta}
              selectedLane={selectedLane}
              onLaneChange={setSelectedLane}
            />
          )}
        </>
      )}
    </div>
  );
}
